module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customAddress":"Custom Address","edit":"Edit","failedToFetch":"Failed to search for addresses","position":"Position"},"no":{"customAddress":"Ny adresse","edit":"Rediger","failedToFetch":"Kunne ikke søke etter adresser","position":"Posisjon"}}')
  delete Component.options._Ctor
}
